import AISuggestion, {
    AiSuggestionsConversationList,
    AiSuggestionsCustomViewCreationList,
} from "@/domain/enums/AISuggestions";
import { queryKeys, STALE_TIME } from "@/lib/queryKeys";
import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";

const useGetAISuggestions = ({
    suggestionType,
    count = 4,
}: {
    suggestionType: AISuggestion;
    count?: number;
}) => {
    const { t } = useTranslation();

    const getSuggestions = () => {
        const suggestionsKeys = Object.values(
            suggestionType === AISuggestion.Conversation
                ? AiSuggestionsConversationList
                : AiSuggestionsCustomViewCreationList,
        );
        // Shuffle the keys to avoid duplicates and take the first 'count' elements
        const shuffledKeys = suggestionsKeys.sort(() => 0.5 - Math.random());
        const selectedKeys = shuffledKeys.slice(0, count);

        return selectedKeys.map((key) =>
            t(`AISuggestions.${suggestionType}.${key}`),
        );
    };

    const suggestions = useQuery({
        queryKey: queryKeys.suggestions(suggestionType),
        queryFn: getSuggestions,
        staleTime: STALE_TIME.realtime,
    });

    return suggestions.data || [];
};

export default useGetAISuggestions;
